export const isDefined = <T>(value: T | undefined | null): value is T => {
  return value !== undefined && value !== null;
};

export const isNotDefined = <T>(value: T | undefined | null): value is undefined | null => {
  return !isDefined(value);
};

export const isEmpty = (value: string) => {
  return value.trim() === '';
};

export const isEmptyOrNotDefined = (value: string | undefined | null): value is Exclude<string, undefined | null> => {
  return isNotDefined(value) || value.trim() === '';
};

export const isNotEmpty = (value: string | undefined | null): value is Exclude<string, undefined | null> => {
  return !isEmptyOrNotDefined(value);
};
